import { getSwappedValues, getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { footballOnServeHandler } from "./onServeHandler";
import { numberMap } from "../config";
const getFormattedPart = (part, dict) => dict.myBetsDictionary[numberMap[part]] || `${part}${dict.myBetsDictionary.Nth}`;
const prefixSingleTime = (time) => time < 10 ? `0${time}` : time;
const formatTimer = (gameTime) => {
    const minutes = Math.floor((gameTime % (1000 * 120 * 120)) / (1000 * 60));
    const seconds = Math.floor((gameTime % (1000 * 60)) / 1000);
    return `${prefixSingleTime(minutes)}:${prefixSingleTime(seconds)}`;
};
const getDefaultPlaceholder = (timer, dict) => timer.gameTime !== undefined ? dict.myBetsDictionary.TimePlacholder : dict.myBetsDictionary.DefaultPlacholder;
const getGamePart = (gamePart, dict) => dict.myBetsDictionary[gamePart] || gamePart;
const concatenateDistanceDataToShortLabel = (additionalScores, dict, shortLabel) => {
    const americanFootballCurrentDown = getTruthyValue(+additionalScores.americanFootballCurrentDown, 0);
    const americanFootballYardsToGo = getTruthyValue(+additionalScores.americanFootballYardsToGo, -1);
    if (americanFootballYardsToGo !== -1 && americanFootballCurrentDown > 0) {
        return `${shortLabel}, ${getFormattedPart(americanFootballCurrentDown.toString(), dict)} ${dict.myBetsDictionary.And} ${americanFootballYardsToGo}`;
    }
    return shortLabel;
};
const concatenateGetFieldData = (additionalScores, isTeamSwap, participants, shortLabel) => {
    var _a;
    const onServe = footballOnServeHandler(additionalScores.americanFootballPosession, "1");
    const [teamOneOnServe] = getSwappedValues(isTeamSwap, onServe, !onServe);
    const americanFootballYardLine = +additionalScores.americanFootballYardLine;
    if (americanFootballYardLine !== -1 && participants.length > 1) {
        const swappedParticipants = getSwappedValues(isTeamSwap, participants[0], participants[1]);
        const { yeardLine, shortTeamIndex } = getAmericanFootballSpecificData(teamOneOnServe, americanFootballYardLine);
        const shortName = getTruthyValue((_a = swappedParticipants[shortTeamIndex].metadata) === null || _a === void 0 ? void 0 : _a.shortName, "");
        return shortName ? `${shortLabel} ${shortName} ${yeardLine}` : shortLabel;
    }
    return shortLabel;
};
export const createAmricanFootbalShortLabel = (additionalScores, dict, timer, participants = [], isTeamSwap = false) => {
    let shortLabel = createDefaultShortLabel(additionalScores, dict, timer);
    shortLabel = concatenateDistanceDataToShortLabel(additionalScores, dict, shortLabel);
    shortLabel = concatenateGetFieldData(additionalScores, isTeamSwap, participants, shortLabel);
    return shortLabel;
};
export const createBaseballShortLabel = (additionalScores, dict) => {
    let placeholder = additionalScores.baseballOuts ? `${dict.myBetsDictionary.BaseballPlaceholder} ${dict.myBetsDictionary.Out}` : `${dict.myBetsDictionary.BaseballPlaceholderWithotuOuts}`;
    const updateAdditionalScores = Object.assign(Object.assign({}, additionalScores), { gamePart: getGamePart(additionalScores.gamePart, dict) });
    ["batting", "gamePart", "baseballOuts"].forEach((key, index) => {
        placeholder = placeholder.replace(`{${index}}`, updateAdditionalScores[key] || "-");
    });
    return placeholder;
};
export const getAmericanFootballSpecificData = (teamOneOnServe, americanFootballYardLine) => {
    if (americanFootballYardLine > 50) {
        return {
            yeardLine: 100 - americanFootballYardLine,
            shortTeamIndex: +teamOneOnServe
        };
    }
    return {
        yeardLine: americanFootballYardLine,
        shortTeamIndex: +(!teamOneOnServe)
    };
};
export const createDefaultShortLabel = (additionalScores, dict, timer) => {
    const placeholder = getDefaultPlaceholder(timer, dict).replace("{time}", formatTimer(getTruthyValue(timer.gameTime, 0)));
    return placeholder.replace("{0}", getGamePart(additionalScores.gamePart, dict));
};
//# sourceMappingURL=createShortLabel.js.map